import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { to: '/admin',                label: 'Monitoring',      exact: true },
  { to: '/admin/users',          label: 'Users' },
  { to: '/admin/system',         label: 'System' },
  { to: '/admin/classification', label: 'Classification' },
];

export default function AdminShellLayout() {
  const [allowed, setAllowed] = useState<boolean | null>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    fetch('/api/auth/is-admin')
      .then(res => res.ok ? res.json() : Promise.reject())
      .then((data: { isAdmin: boolean }) => {
        if (!data.isAdmin) { navigate('/'); return; }
        setAllowed(true);
      })
      .catch(() => navigate('/'));
  }, [navigate]);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  if (allowed === null) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', color: 'var(--text-secondary)', fontSize: 14 }}>
        Loading…
      </div>
    );
  }

  if (isMobile) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--background, #f9fafb)' }}>
        <header style={{
          background: 'var(--surface, #fff)',
          borderBottom: '1px solid var(--border, #e5e7eb)',
          padding: '10px 16px',
          display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px 12px',
        }}>
          <span style={{ fontWeight: 700, fontSize: 14, marginRight: 4 }}>Admin</span>
          <nav style={{ display: 'flex', flexWrap: 'wrap', gap: 4, flex: 1 }}>
            {navItems.map(({ to, label, exact }) => {
              const active = exact ? pathname === to : pathname.startsWith(to);
              return (
                <Link
                  key={to}
                  to={to}
                  style={{
                    padding: '4px 10px',
                    borderRadius: 6,
                    fontSize: 13,
                    textDecoration: 'none',
                    fontWeight: active ? 600 : 400,
                    color: active ? 'var(--accent, #2563eb)' : 'var(--text-primary, #111)',
                    background: active ? 'var(--accent-subtle, #eff6ff)' : 'transparent',
                  }}
                >
                  {label}
                </Link>
              );
            })}
          </nav>
          <a href="/app/dashboard" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: 12, whiteSpace: 'nowrap' }}>← App</a>
        </header>
        <main style={{ flex: 1, padding: '16px 12px', overflowY: 'auto' }}>
          <Outlet />
        </main>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--background, #f9fafb)' }}>
      <aside style={{
        width: 200, flexShrink: 0,
        background: 'var(--surface, #fff)',
        borderRight: '1px solid var(--border, #e5e7eb)',
        display: 'flex', flexDirection: 'column',
        padding: '24px 0',
      }}>
        <div style={{ padding: '0 20px 24px', fontWeight: 700, fontSize: 14 }}>
          Admin
        </div>
        <nav style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '0 8px' }}>
          {navItems.map(({ to, label, exact }) => {
            const active = exact ? pathname === to : pathname.startsWith(to);
            return (
              <Link
                key={to}
                to={to}
                style={{
                  padding: '7px 12px',
                  borderRadius: 6,
                  fontSize: 13,
                  textDecoration: 'none',
                  fontWeight: active ? 600 : 400,
                  color: active ? 'var(--accent, #2563eb)' : 'var(--text-primary, #111)',
                  background: active ? 'var(--accent-subtle, #eff6ff)' : 'transparent',
                }}
              >
                {label}
              </Link>
            );
          })}
        </nav>
        <div style={{ marginTop: 'auto', padding: '16px 20px 0', borderTop: '1px solid var(--border)', fontSize: 12 }}>
          <a href="/app/dashboard" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>← Back to app</a>
        </div>
      </aside>
      <main style={{ flex: 1, padding: '32px', overflowY: 'auto' }}>
        <Outlet />
      </main>
    </div>
  );
}
